import {VTabs, VTab, VTabsItems, VTabItem, VBtn} from 'vuetify/lib'
import Header from '../components/Header.jsx'
import FundSecurity from '../components/FundSecurity.jsx'
import General from './components/General.jsx'
import CapitalGains from '../components/CapitalGains.jsx'
import styles from '../index.module.less'
import ContainMixIns from '../ContainMixIns'
const list = [
    {
        title: '集团资金概况',
        Component: General
    },
    {
        title: '集团资金安全情况',
        Component: FundSecurity
    },
    {
        title: '集团资金收益情况',
        Component: CapitalGains
    }
]
export default {
    mixins: [ContainMixIns],
    data() {
        return {
          
        }
    },
    render() {
        const _this = this
        return <div>
            <Header 
                v-model={_this.params}
                isRange
                disabledRadio={_this.canEdit}
                on={{
                    change: _this.changeHeader
                }}
            />
            <div class={styles['df']}>
                <div class={styles['df-1']}>
                    <VTabs v-model={_this.tab} on={{change:(val) => {
                        _this.changeTable(val)
                    }}}>
                        {list.map(item => <VTab>{item.title}</VTab>)}
                    </VTabs>
                </div>
                {_this.tab === 1 && <div style="margin:8px 0" >
                    <VBtn color="primary" on={{
                        click: () => {
                            if (!_this.canEdit) {
                                _this.canEdit = true
                                _this.params.unit = 1
                                _this.editFunProxy()
                            } else {
                                _this.saveChildProxy()
                            }
                        }
                    }}>
                        {_this.canEdit ? '生效' : '编辑'}
                    </VBtn>
                   { _this.canEdit && <VBtn style="margin-left:8px" on={{
                        click: () => {
                            _this.canEdit = false
                        }
                    }}>
                       取消
                    </VBtn>}
                </div>}
            </div>
            <VTabsItems v-model={_this.tab}>
                {list.map((item, index) => {
                    const Component = item.Component
                    return <VTabItem key={index}flat>
                    <Component
                        header={_this.header}
                        ref={index}
                        params={_this.params}
                        canEdit={_this.canEdit}
                        on={{
                            success:() => {
                                if (_this.tab === 1) {
                                    _this.changeTable()
                                }
                            }
                        }}
                    />
                </VTabItem>
                })}
            </VTabsItems>
        </div>
    }
}